import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Err} from '../../../err';
import EMAIL_REGEX from '../../../validators/regex/email.regex';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  form: FormGroup;
  submitted = false;
  message = '';

  constructor(private builder: FormBuilder,
              private service: UserService,
              private router: Router,
              public translate: TranslateService) {
    translate.use('nl');
    this.form = builder.group({
      username: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  get f() { return this.form.controls; }

  onSubmit(credentials): void {
    this.message = '';
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    this.service.login(credentials.username.trim(), credentials.password.trim()).pipe().subscribe(() => {
        const dest = this.service.isUser() || this.service.isAdmin() ? '' : '/rapportage/definitief';
        this.router.navigate([dest]);
      }, response => {
      const error = Err[response.error.message.split(' ')[0]];
      if (error === Err.USER_NOT_ACTIVATED)
        this.router.navigate(['/activatie/' + response.error.message.split(' ')[1]]);
      this.message = error;
    });
  }

  emailChanged(email) {
    if (email.match(EMAIL_REGEX)) {
      this.service.shouldActivate(email).subscribe(res => {
        if (res.shouldActivate) {
          this.router.navigate(['/activatie/' + res.userId]);
        }
      });
    }
  }
}
